var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8254 12.7246V16.3045C16.8248 16.4892 16.7509 16.6661 16.6201 16.7964C16.4892 16.9268 16.3121 17 16.1274 17H1.69551C1.51237 17 1.33662 16.9278 1.2064 16.799C1.07619 16.6702 1.00202 16.4953 1 16.3121V7.70007",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.70008V6.24257C1 6.03912 1.08082 5.84401 1.22468 5.70014C1.36854 5.55628 1.56366 5.47546 1.76711 5.47546",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11747 6.956C2.32365 6.956 2.49079 6.78886 2.49079 6.58268C2.49079 6.37649 2.32365 6.20935 2.11747 6.20935C1.91128 6.20935 1.74414 6.37649 1.74414 6.58268C1.74414 6.78886 1.91128 6.956 2.11747 6.956Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60563 6.956C3.81181 6.956 3.97895 6.78886 3.97895 6.58268C3.97895 6.37649 3.81181 6.20935 3.60563 6.20935C3.39944 6.20935 3.2323 6.37649 3.2323 6.58268C3.2323 6.78886 3.39944 6.956 3.60563 6.956Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09635 6.956C5.30253 6.956 5.46967 6.78886 5.46967 6.58268C5.46967 6.37649 5.30253 6.20935 5.09635 6.20935C4.89017 6.20935 4.72302 6.37649 4.72302 6.58268C4.72302 6.78886 4.89017 6.956 5.09635 6.956Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6077 12.5201L17.3547 11.2646",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4082 10.1344L19.6995 11.4283",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0619 1.62204C12.0843 1.10566 13.2368 0.903988 14.3737 1.04253C15.5106 1.18108 16.581 1.65361 17.4494 2.4004C18.3178 3.14719 18.9453 4.13469 19.2525 5.23807C19.5598 6.34144 19.533 7.51114 19.1755 8.59928C18.818 9.68741 18.1459 10.6451 17.2442 11.3513C16.3425 12.0576 15.2517 12.4806 14.1096 12.5669C12.9675 12.6532 11.8254 12.3989 10.8278 11.8362C9.83021 11.2735 9.02184 10.4277 8.50491 9.40563C8.16152 8.7267 7.95527 7.98676 7.89794 7.22809C7.84061 6.46942 7.93332 5.70689 8.17078 4.98406C8.40824 4.26123 8.78579 3.59228 9.28187 3.01541C9.77794 2.43854 10.3828 1.96507 11.0619 1.62204V1.62204Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9712 3.51169C17.619 4.15974 18.0601 4.98532 18.2388 5.88406C18.4174 6.78279 18.3256 7.71432 17.9749 8.56085C17.6241 9.40739 17.0303 10.1309 16.2683 10.64C15.5064 11.149 14.6107 11.4207 13.6944 11.4207C12.7781 11.4207 11.8823 11.149 11.1204 10.64C10.3585 10.1309 9.76462 9.40739 9.41388 8.56085C9.06315 7.71432 8.9713 6.78279 9.14995 5.88406C9.3286 4.98532 9.76972 4.15974 10.4175 3.51169C10.8478 3.08128 11.3587 2.73985 11.9209 2.5069C12.4831 2.27395 13.0858 2.15405 13.6944 2.15405C14.303 2.15405 14.9056 2.27395 15.4678 2.5069C16.0301 2.73985 16.5409 3.08128 16.9712 3.51169V3.51169Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.686 16.4528L23.6323 16.5065C23.4218 16.7164 23.1368 16.8342 22.8396 16.8342C22.5424 16.8342 22.2573 16.7164 22.0469 16.5065L18.6 13.0571C18.5652 13.0226 18.5376 12.9816 18.5188 12.9364C18.4999 12.8912 18.4902 12.8427 18.4902 12.7937C18.4902 12.7447 18.4999 12.6962 18.5188 12.651C18.5376 12.6058 18.5652 12.5648 18.6 12.5303L19.7098 11.4206C19.7443 11.3858 19.7853 11.3582 19.8305 11.3393C19.8757 11.3205 19.9242 11.3108 19.9732 11.3108C20.0221 11.3108 20.0706 11.3205 20.1158 11.3393C20.161 11.3582 20.2021 11.3858 20.2365 11.4206L23.686 14.8675C23.8958 15.0779 24.0137 15.363 24.0137 15.6601C24.0137 15.9573 23.8958 16.2424 23.686 16.4528V16.4528Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0218 7.70007H1",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09084 5.46527H1.77734",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8959 8.92677C12.8118 8.92711 12.7284 8.91067 12.6507 8.8784C12.573 8.84613 12.5024 8.79869 12.4432 8.73882L11.1607 7.45515C11.0403 7.33477 10.9726 7.1714 10.9724 7.00097C10.9722 6.83055 11.0396 6.66703 11.1597 6.54638C11.2797 6.42574 11.4427 6.35786 11.6127 6.35767C11.7827 6.35748 11.9458 6.42501 12.0662 6.54538L12.8959 7.37717L15.5048 4.76784C15.6249 4.64746 15.7877 4.57983 15.9576 4.57983C16.1274 4.57983 16.2902 4.64746 16.4103 4.76784C16.5304 4.88822 16.5979 5.05148 16.5979 5.22172C16.5979 5.39196 16.5304 5.55523 16.4103 5.67561L13.3487 8.73882C13.2894 8.7986 13.2188 8.84599 13.1411 8.87825C13.0634 8.91051 12.98 8.927 12.8959 8.92677Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.7e260ba8d3b40b14cd7fc658b57a052a.svg";
export { ForwardRef as ReactComponent };